export default __webpack_public_path__ + "static/media/photo-participant.1c6498e1.jpg";